export const VISIT_REASONS = 'visit_reasons';
export const LOCATIONS = 'locations';
export const RESOURCES = 'resources';
